import { useState } from "react"
import { useDeleteGGNLocation } from "../../api/useWeatherGGN"
import { Report } from "../../interfaces/intakes.reports"
import { GGNSingleWeather } from "../ggn/GGNSingleWeather"
import { ModalGGNLocations } from "../ggn/ModalGGNLocations"
import { useQueryClient } from "@tanstack/react-query"
import { IoPartlySunnyOutline } from "react-icons/io5";
import { AccordionCard } from "../cards/AccordionCard"

interface Props {
    report: Report
}
export const WeatherCard = ({ report }: Props) => {

    const { mutate, isLoading } = useDeleteGGNLocation()
    const [openGGN, setOpenGGN] = useState<boolean>(false)

    const queryClient = useQueryClient()

    const handleDeleteGGN = (ggn_number: string) => {
        mutate({
            reportId: report._id,
            ggn_number
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries(['reportTemp', report._id])
            }
        })
    };

    return (
        // <div className='mb-2 tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-4 tw-shadow-blue-800/10'>
        <AccordionCard
            title='Weather'
            className="mb-2"
            defaultOpen={false}
            additionalBtn={<button
                className='btn-copy ml-05'
                onClick={() => setOpenGGN(true)}
            >
                <IoPartlySunnyOutline size={16} color="#1A73E8" />
            </button>}
        >

            {
                openGGN &&
                <ModalGGNLocations
                    closeModal={() => setOpenGGN(false)}
                    reportId={report._id}
                    weather={report.weather || []}
                    isEdit //Para editar uno nuevo, pasando a paso 2 directamente
                    mainData_loading_date={report.mainData.harvest_day || report.mainData.loading_date ? new Date(report.mainData.harvest_day || report.mainData.loading_date) : new Date()}
                />
            }

            {
                report.weather?.length > 0 
                ?
                report.weather.map(location => (
                    <GGNSingleWeather key={location.city} location={location} handleDeleteGGN={handleDeleteGGN} isLoading={isLoading} isFull />
                ))
                : <p className="tw-text-center tw-text-sm">No weather data</p>
            }
        </AccordionCard>

    )
}
